export function normalizeRank(r) {
  if (typeof r.rank === "number" && !isNaN(r.rank)) {
    return { value: r.rank, label: `#${r.rank}` }; // exact rank
  }
  if (r.placement) {
    switch (r.placement) {
      case "Top8": return { value: 8, label: "Top 8" };
      case "Top16": return { value: 16, label: "Top 16" };
      case "Top32": return { value: 32, label: "Top 32" };
      case "Top64": return { value: 64, label: "Top 64" };
      case "Top68": return { value: 68, label: "Top 68" };
      default: return null;
    }
  }
  return null; // ignore Withdraw, W/O, etc.
}
